<template>
    <div class="orders">
        <order v-for="order in finishedOrders" :key="order.id" :order="order" :history=true></order>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {mapGetters} from 'vuex'
    import Order from './Order'

    export default {
        name: 'Orders',
        components: {
            Order,
        },
        data() {
            return {
                menuVisible: false,
                searchTerm: ''
            }
        },
        computed: {
            ...mapGetters('dashboard', [
                'location',
                'filterNumber'
            ]),
            finishedOrders: function() {
                return this.location.history.filter(order => (order.picked_up || order.canceled)).sort(function(a,b){
                    return new Date(b.updated_at) - new Date(a.updated_at);
                });
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    .orders {
        height: 100%;
        display: flex;
        justify-content: left;
        overflow: auto;
        padding: 15px 0;
    }
</style>
